module.exports = __webpack_public_path__ + "img/2024-08-29d_3.1899b222.jpg";